/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-16 22:37:35
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbGrade {
    /**
     * 获取会员等级列表
     */
    export var GetGradeList = (): Promise<any> => {
        return Get(`/api/TbGrade/GetGradeList`, {});
    };
    /**
     * 获取会员等级列表
     */
    export var GetTbGradeList = (): Promise<any> => {
        return Get(`/api/TbGrade/GetTbGradeList`, {});
    };
    /**
     * 新增会员等级信息
     */
    export var PostGrade = (body:any): Promise<any> => {
        return Post(`/api/TbGrade/PostGrade`, body);
    };
    /**
     * 查询会员等级信息
     */
    export var GetTbGradeById = (body:any): Promise<any> => {
        return Get(`/api/TbGrade/GetTbGradeById`, body);
    };
    /**
     * 修改会员等级信息
     */
    export var PutTbGrade = (body:any): Promise<any> => {
        return Put(`/api/TbGrade/PutTbGradeV2`, body);
    };
    /**
     * 删除会员等级信息
     */
    export var DeleteGrade = (id:any): Promise<any> => {
        return Delete(`/api/TbGrade/DeleteGrade?id=${id}`, {});
    };
    
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbGrade.ts